import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import TypeList from './type-list'
import NewCar, { NewCarSeriesInfo } from './new-car'
import PopularModels from './popular-model'
import TryCatchRender from 'Components/try-catch-render'

interface IProps {
  newCarData: NewCarSeriesInfo[]
  popularModels: any
}

export default TryCatchRender(function ChooseCar({
  newCarData,
  popularModels,
}: IProps) {
  const [ref, inView] = useInView({
    threshold: 0,
  })
  useEffect(() => {
    if (inView) {
      // - 选车模块：select_module
      sendTeaCommEvent('show_event', {
        event_id: 'common_conponent_module',
        module_id: 'select_module',
      })
      // - 近期重磅新车： recent_car_module
      sendTeaCommEvent('show_event', {
        event_id: 'common_conponent_module',
        module_id: 'recent_car_module',
      })
    }
  }, [inView])

  return (
    <>
      <div
        className="choose-car-wrap tw-grid tw-gap-12 tw-grid-cols-4 2xl:tw-grid-cols-5 tw-w-full"
        ref={ref}
      >
        <div className="tw-col-span-3 2xl:tw-col-span-4">
          <TypeList />
          <PopularModels popularModels={popularModels} />
        </div>
        <section>
          <NewCar newCarData={newCarData} />
        </section>
        <style jsx>
          {`
            .choose-car-wrap {
              padding-bottom: 24px;
            }
          `}
        </style>
      </div>
    </>
  )
})
